/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_BarInputs */

const en_services_flow_bar = /** @type {(inputs: Services_Flow_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built around your business`)
};

const lv_services_flow_bar = /** @type {(inputs: Services_Flow_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidots ap Jūsu uzņēmumu`)
};

/**
* | output |
* | --- |
* | "Built around your business" |
*
* @param {Services_Flow_BarInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_bar = /** @type {((inputs?: Services_Flow_BarInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_BarInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_bar(inputs)
	return en_services_flow_bar(inputs)
});